import { CONTACT } from '../constants'

type StampProps = {
  className?: string
  size?: 'md' | 'lg'
  subject?: string
  label?: string
}

export function Stamp({
  className = '',
  size = 'md',
  subject,
  label = 'Write to',
}: StampProps) {
  const scale =
    size === 'lg'
      ? 'text-lg sm:text-xl lg:text-2xl px-6 py-4'
      : 'text-base px-5 py-3'

  const href = subject
    ? `mailto:${CONTACT}?subject=${encodeURIComponent(subject)}`
    : `mailto:${CONTACT}`

  return (
    <a href={href} className={`stamp ${scale} ${className}`}>
      <span className="cell-label text-overprint">{label}</span>
      <span>{CONTACT}</span>
    </a>
  )
}
